import styled from 'styled-components';
import React from 'react';
import { IconExclamationCircle, LogoSpotify, } from '@spotify-internal/encore-web';
import { EventSource } from '../../graphql/graphql';
const MessageStateContainer = styled.div `
  flex-shrink: 0;
  width: 0.8rem;
  display: flex;
  align-items: end;
`;
const MessageIconFail = styled(IconExclamationCircle) `
  flex-shrink: 0;
  align-self: end;
  color: #e91429;
  min-width: 1.25rem;
`;
const MessageLoadingSpinner = styled.div.attrs({
    'data-testid': 'loading-indicator',
}) `
  flex-shrink: 0;
  display: inline-block;
  align-self: end;
  width: 0.75rem;
  height: 0.76rem;
  border-radius: 50%;
  border: 2px solid #8f8f8f;
  border-top-color: transparent;
  animation: spin 0.7s linear infinite;
  transform-origin: center;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
const AdvisorProfilePicture = styled(LogoSpotify) `
  fill: ${props => props.$fillColor || '#3629ed'};
  background-color: ${props => props.$backgroundColor || '#fff'};
  border-radius: 50%;
  flex-shrink: 0;
  align-self: end;
  @media print {
    display: none;
  }
`;
export const EmptyMarginStart = styled.span `
  min-width: 1.65rem;
`;
const MessageState = ({ event }) => {
    if (event.failed) {
        return React.createElement(MessageIconFail, { iconSize: 16 });
    }
    else if (event.loading) {
        return React.createElement(MessageLoadingSpinner, { color: "#727272" });
    }
    return React.createElement(React.Fragment, null);
};
export const MessageIcon = ({ event, iconColor, }) => {
    const isAdvisor = event.source === EventSource.Advisor;
    return isAdvisor ? (React.createElement(AdvisorProfilePicture, { "$fillColor": iconColor, condensed: true, width: "24", height: "24" })) : (React.createElement(MessageStateContainer, null,
        React.createElement(MessageState, { event: event })));
};
